module.exports = __webpack_public_path__ + "static/media/coinLogoy.4684aa08.png";